import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthActionsUnion, AuthActionTypes } from '@core/actions/auth.actions';

export interface State {
  loggingIn: boolean;
  loggedIn: boolean;
  token: string;
}

export const INITIAL_STATE: State = {
  loggingIn: false,
  loggedIn: false,
  token: null
};

export function reducer(
  state: State = INITIAL_STATE,
  action: AuthActionsUnion
) {
  switch (action.type) {
    case AuthActionTypes.Login:
      return { ...state, loggingIn: true, loggedIn: false };

    case AuthActionTypes.LoginFail:
      return { ...state, loggingIn: false, loggedIn: false };

    case AuthActionTypes.LoginSuccess:
      return { ...state, loggingIn: false, loggedIn: true };

    case AuthActionTypes.SetToken:
      return { ...state, token: action.token };

    case AuthActionTypes.LogoutSuccess:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export const selectLoggingIn = (state: State) => state.loggingIn;
export const selectLoggedIn = (state: State) => state.loggedIn;
export const selectToken = (state: State) => state.token;

export const getFeature = createFeatureSelector('auth');
export const getToken = createSelector(getFeature, selectToken);
export const getLoggedIn = createSelector(getFeature, selectLoggedIn);
export const getLoggingIn = createSelector(getFeature, selectLoggingIn);
export const getBusyLogin = createSelector(
  getLoggedIn,
  getLoggingIn,
  (loggedIn, loggingIn) => !loggedIn && loggingIn
);
